<template>
    <div>
        <Head :title="__(title)" />
        <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
            <form @submit.prevent="update">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Description')" />
                </div>
                <div class="flex">
                    <div class="p-8 -mr-6 -mb-8 flex">
                        <text-input type="number" v-model="form.nday" :error="form.errors.nday" class="pr-6 pb-8 w-full  " :label="__('# Days')" />
                    </div>
                    <div class="p-8 -mr-6 -mb-8 flex">
                        <text-input type="number" v-model="form.ndaymax" :error="form.errors.ndaymax" class="pr-6 pb-8 w-full  " :label="__('# Days Max')" />
                    </div>
                    <div class="p-8 -mr-6 -mb-8 flex">
                        <text-input type="color" v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full " :label="__('Color')" />
                    </div>
                </div>
        

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
                    <button v-if="!type.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('Delete') }}</button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo() {
        return { title: this.form.description }
    },
    components: {
        LoadingButton,
        TextInput,
        Link,
        Head,
    },
    layout: Layout,
    props: {
        description: String,
        nday: String,
        ndaymax: String,
        color : String,
        type: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                description: this.type.description,
                nday : this.type.nday,
                ndaymax : this.type.ndaymax,
                color :  this.type.color
            }),
        }
    },
    methods: {
        update() {
            this.form.put(this.route('venciment-color.update', this.type.id))
        },
        destroy() {
            if (confirm('Are you sure you want to delete this type?')) {
                this.$inertia.delete(this.route('venciment-color.destroy', this.type.id))
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this type?')) {
                this.$inertia.put(this.route('venciment-color.restore', this.type.id))
            }
        },
    },
}
</script>
